export function zeroSinceHH(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCHours(0, 0, 0, 0);
}
export function zeroSinceSS(millisSinceEpoch) {
    return new Date(millisSinceEpoch).setUTCSeconds(0, 0);
}
export function betweenDateTimeTransform(betweenMatcherData) {
    return {
        dataType: betweenMatcherData.dataType,
        start: zeroSinceSS(betweenMatcherData.start),
        end: zeroSinceSS(betweenMatcherData.end)
    };
}
